import { useState, useEffect, useCallback } from "react";
import { toast } from "sonner";
import adminApi from "@/lib/adminApi";
import { Input } from "@/components/ui/input";
import { Switch } from "@/components/ui/switch";
import { Avatar } from "@/components/comments/CommentMeta";

const TOGGLES = [
  ["role", "Moderador", (f) => f.role === "moderator", (on) => (on ? "moderator" : "user")],
  ["is_subscriber", "Premium", (f) => f.is_subscriber, (on) => on],
  ["banned", "Bloqueado", (f) => f.banned, (on) => on],
];

export default function FansTab() {
  const [search, setSearch] = useState("");
  const [fans, setFans] = useState([]);

  const load = useCallback(async () => {
    const res = await adminApi.get("/admin/fans", { params: { search } });
    setFans(res.data);
  }, [search]);

  useEffect(() => {
    const t = setTimeout(load, 300);
    return () => clearTimeout(t);
  }, [load]);

  const update = async (fan, field, value) => {
    const res = await adminApi.put(`/admin/fans/${fan.user_id}`, { [field]: value });
    setFans((prev) => prev.map((f) => (f.user_id === fan.user_id ? { ...f, ...res.data } : f)));
    toast.success("Usuario actualizado");
  };

  return (
    <div className="bg-white border border-gray-200 rounded-2xl p-4 md:p-6 shadow-sm" data-testid="admin-fans-tab">
      <Input value={search} onChange={(e) => setSearch(e.target.value)} placeholder="Buscar por nombre o email..." className="md:max-w-xs mb-4 bg-gray-50 border-gray-200 text-black" data-testid="admin-fans-search" />
      {fans.length === 0 ? (
        <p className="text-gray-500 text-sm py-8 text-center" data-testid="admin-fans-empty">Aún no hay usuarios registrados</p>
      ) : (
        <div className="divide-y divide-gray-100">
          {fans.map((f) => (
            <div key={f.user_id} className="py-3 flex flex-col md:flex-row md:items-center gap-3" data-testid={`admin-fan-${f.user_id}`}>
              <div className="flex items-center gap-3 flex-1 min-w-0">
                <Avatar author={f} />
                <div className="min-w-0">
                  <p className="font-bold text-black text-sm truncate">{f.name}</p>
                  <p className="text-xs text-gray-500 truncate">{f.email} · {f.comment_count} comentarios</p>
                </div>
              </div>
              <div className="flex items-center gap-4">
                {TOGGLES.map(([field, label, isOn, toValue]) => (
                  <label key={field} className="flex items-center gap-2 text-xs text-gray-600">
                    <Switch checked={isOn(f)} onCheckedChange={(on) => update(f, field, toValue(on))} data-testid={`admin-fan-${field}-${f.user_id}`} />
                    {label}
                  </label>
                ))}
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
